import React from "react";
import "../../styles/testHeader.css";

const TestTimer = ({ timeRemaining }) => {
  if (timeRemaining == null) return null;

  const minutes = Math.floor(timeRemaining / 60);
  const seconds = timeRemaining % 60;

  return (
    <div className="test-header-timer">
      {minutes}:{seconds.toString().padStart(2, "0")}
    </div>
  );
};

export default TestTimer;
